<template>
  <div class="container">
    <div class="back" @click="back">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('guidanceReports.back') }}</span>
    </div>
    <div class="anchor">
      <div v-for="(i, inx) in getAnchorList" :key="inx" @click="changeAnchor(i)">
        <a :style="{ fontWeight: i.checked ? 'bold' : '' }">{{ i.name }}</a>
        <div class="checked" v-show="i.checked"></div>
      </div>
    </div>
    <div class="scrollContent">
      <div :id="$t('guidanceReports.basicData')" class="base">
        <div class="title">
          <span>{{ $t('guidanceReports.basicData') }}</span>
          <a-button type="primary" @click="exportExcel"> {{ $t('guidanceReports.exportReport') }} </a-button>
        </div>
        <a-table :locale="locale" :columns="classColumns" :data-source="baseData"></a-table>
      </div>
      <div :id="$t('guidanceReports.guidanceDetail')">
        <div class="title">
          <span>{{ $t('guidanceReports.guidanceDetail') }}</span>
        </div>
        <a-table :locale="locale" :columns="guidanceColumns" :data-source="detail">
          <template slot="action" slot-scope="text, record">
            <a-button type="link" @click="handleDetail(record)" :disabled="$route.query.guidanceType !== '4'">{{ $t('guidanceReports.viewDetails') }}</a-button>
          </template>
        </a-table>
      </div>
    </div>
    <a-modal class="guidanceModal" v-model="visible" width="800" :title="$t('guidanceReports.viewPreview')" :footer="null">
      <a-table :columns="columns" :data-source="data" bordered />
    </a-modal>
  </div>
</template>
<script>
import { exportLessonGuidance, lessonGuidanceDetail } from '@/api/lesson'
import { i18nRender } from '@/locales'
import NoData from '@/components/noData/index'
import Pagination from '@/components/pagination/index.vue'
import { formatSeconds } from '@/utils/util'

export default {
  components: {
    NoData,
    Pagination
  },
  data() {
    return {
      id: undefined,
      guidanceData: [
        {
          name: '学生1'
        }
      ],
      tabKey: 1,
      locale: {
        emptyText: <NoData />
      },
      trainingDetailKey: undefined,
      detail: [],
      baseData: [],
      classColumns: [
        {
          title: this.$t('guidanceReports.class'),
          key: 'className',
          align: 'center',
          dataIndex: 'className'
        },
        {
          title: this.$t('guidanceReports.studentCount'),
          align: 'center',
          key: 'studentCount',
          dataIndex: 'studentCount'
        },
        {
          title: this.$t('guidanceReports.participatingStudents'),
          key: 'participateStudentCount',
          align: 'center',
          dataIndex: 'participateStudentCount'
        },
        {
          align: 'center',
          title: this.$t('guidanceReports.guidanceParticipationRate'),
          key: 'participateStudentRate',
          dataIndex: 'participateStudentRate'
        }
      ],
      guidanceColumns: [
        {
          title: this.$t('guidanceReports.student'),
          key: 'studentName',
          align: 'center',
          dataIndex: 'studentName'
        },
        {
          title: this.$t('guidanceReports.totalStudyDuration'),
          align: 'center',
          key: 'studyDuration',
          dataIndex: 'studyDuration'
        },
        {
          title: this.$t('guidanceReports.details'),
          key: 'action',
          align: 'center',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      getAnchorList: [
        {
          name: this.$t('guidanceReports.basicData'),
          checked: true
        },
        {
          name: this.$t('guidanceReports.guidanceDetail'),
          checked: false
        }
      ],
      attendanceList: [],
      trainingList: [],
      teachList: [],
      overviewAttendance: {},
      overviewTraining: {},
      overviewTeach: {},
      columns: [
        {
          title: this.$t('guidanceReports.learningChapter'),
          dataIndex: 'chapter',
          key: 'chapter',
          customRender: (text, row, index) => {
            const obj = {
              children: text,
              attrs: {}
            }
            if (row.isFirstRow) {
              obj.attrs.rowSpan = row.rowSpan
            } else {
              obj.attrs.rowSpan = 0
            }
            return obj
          }
        },
        {
          title: this.$t('guidanceReports.studyDuration'),
          dataIndex: 'totalTime',
          key: 'totalTime',
          customRender: (text, row, index) => {
            const obj = {
              children: text,
              attrs: {}
            }
            if (row.isFirstRow) {
              obj.attrs.rowSpan = row.rowSpan
            } else {
              obj.attrs.rowSpan = 0
            }
            return obj
          }
        },
        {
          title: this.$t('guidanceReports.questionCount'),
          dataIndex: 'questionCount',
          key: 'questionCount',
          customRender: (text, row, index) => {
            const obj = {
              children: text,
              attrs: {}
            }
            if (row.isFirstRow) {
              obj.attrs.rowSpan = row.rowSpan
            } else {
              obj.attrs.rowSpan = 0
            }
            return obj
          }
        },
        {
          title: this.$t('guidanceReports.question'),
          dataIndex: 'question',
          key: 'question'
        },
        {
          title: this.$t('guidanceReports.options'),
          dataIndex: 'options',
          key: 'options',
          customRender: (text, record) => {
            const correctAnswer = record.correctAnswer // 从 record 中获取正确答案
            const options = text // 选项数组

            // 判断是否是判断题
            const isJudgmentQuestion = correctAnswer === '正确' || correctAnswer === '错误'

            return options.map((option, inx) => {
              if (isJudgmentQuestion) {
                // 判断题逻辑：提取选项内容（去掉 "A、" 或 "B、" 等前缀）
                const optionText = option.split('、')[1]

                // 判断选项内容是否与正确答案一致
                const isCorrect = optionText === correctAnswer

                // 根据是否正确设置颜色
                return (
                  <span style={{ color: isCorrect ? '#4baf1a' : '#000', paddingRight: '5px' }}>
                    {optionText}
                    {/* <i style={{ color: '#888' }}> {inx !== options.length - 1 ? '| ' : ''}</i> */}
                  </span>
                )
              } else {
                // 其他题型逻辑：基于选项字母匹配正确答案
                const optionLetter = option[0] // 获取选项的第一个字符（即选项的字母）

                // 检查该字母是否在正确答案字符串中
                const isCorrect = correctAnswer.includes(optionLetter)

                // 根据是否正确设置颜色
                return (
                  <span style={{ color: isCorrect ? '#4baf1a' : '#000', paddingRight: '5px' }}>
                    {option.length > 8 ? option.substring(0, 8) + '...' : option}
                    {/* {option || optionLetter} */}
                    {/* <i style={{ color: '#888' }}> {inx !== options.length - 1 ? '|' : ''}</i> */}
                  </span>
                )
              }
            })
          }
        },
        {
          title: this.$t('guidanceReports.studentAnswer'),
          dataIndex: 'studentAnswer',
          key: 'studentAnswer',
          customRender: (text, record) => {
            const correctAnswer = record.correctAnswer // 从 record 中获取正确答案
            const studentAnswer = text // 学生答案（假设是一个字符串，例如 "AC"）

            console.log('correctAnswer ----->', correctAnswer)
            console.log('studentAnswer ----->', studentAnswer)

            return studentAnswer.map((option, inx) => {
              const isCorrect = option === correctAnswer

              // 根据是否正确设置颜色
              return (
                <span style={{ color: isCorrect ? '#4baf1a' : '#f50e35' }}>
                  {option}
                  <i style={{ color: '#c3c3c3' }}> {inx !== studentAnswer.length - 1 ? '| ' : ''}</i>
                </span>
              )
            })
          }
        },
        {
          title: this.$t('guidanceReports.passAttempts'),
          dataIndex: 'passCount',
          key: 'passCount'
        }
      ],
      data: [],
      visible: false
    }
  },
  computed: {
    noDataAttendance() {
      return this.attendanceList.length === 0
    },
    noDataTraining() {
      return this.trainingList.length === 0
    },
    noDataTeach() {
      return this.teachList.length === 0
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    formatSeconds(second) {
      return formatSeconds(second)
    },
    changeAnchor(item) {
      const scrollContent = document.querySelector('.scrollContent')
      const section = document.querySelector('#' + item.name)
      scrollContent.scrollTo({ left: 0, top: section.offsetTop - 210, behavior: 'smooth' })
      this.getAnchorList.forEach(item => {
        item.checked = false
      })
      item.checked = true
    },
    // 滚动到对应内容后，改变导航栏
    handleScorll() {
      const scrollContent = document.querySelectorAll('.scrollContent')
      scrollContent.forEach(item => {
        item.addEventListener('scroll', () => {
          const scrollPosition = item.scrollTop + 210
          this.getAnchorList.forEach((link, inx) => {
            const section = document.querySelector('#' + link.name)
            const sectionTop = section.offsetTop
            const sectionHeight = section.clientHeight
            console.log(
              scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight,
              scrollPosition,
              sectionTop,
              scrollPosition,
              sectionTop,
              sectionHeight
            )
            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
              this.getAnchorList[inx].checked = true
            } else {
              this.getAnchorList[inx].checked = false
            }
          })
        })
      })
    },
    exportExcel() {
      exportLessonGuidance({ id: this.id }).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        const name = `${new Date().toLocaleDateString()}${this.$t('guidanceReports.reportSuffix')}`
        console.log('name ----->', name)
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name)
        } else {
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob)
          downloadElement.href = href
          downloadElement.download = name
          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement)
          window.URL.revokeObjectURL(href)
        }
        this.$message.success(this.$t('guidanceReports.downloadSuccess'))
      })
    },
    getLessonData() {
      lessonGuidanceDetail({ id: this.id }).then(res => {
        if (res.code !== 200) return
        this.baseData = [res.data.baseData]
        this.detail = res.data.detail
      })
    },
    generateTableData(challengeData) {
      console.log('challengeData ----->', challengeData)
      const tableData = []
      challengeData.forEach(chapter => {
        const questionCount = chapter.questionInfo.length
        chapter.questionInfo.forEach((question, index) => {
          tableData.push({
            key: `${chapter.chapterName}-${index}`,
            chapter: index === 0 ? chapter.chapterName : '',
            totalTime: chapter.studyDuration,
            questionCount: questionCount,
            question: question.questionBody,
            options: question.options,
            studentAnswer: question.studentAnswer,
            passCount: question.attemptsUntilCorrect,
            correctAnswer: question.answer,
            isFirstRow: index === 0,
            rowSpan: index === 0 ? questionCount : 0
          })
        })
      })
      console.log('tableData ----->', tableData)
      this.data = tableData
    },
    handleDetail(record) {
      this.visible = true
      this.generateTableData(record.challengeData)
    }
  },
  mounted() {
    this.id = Number(this.$route.query.id) || 0
    this.lessonName = this.$route.query.name || undefined
    this.getLessonData()
    this.$nextTick(() => {
      this.handleScorll()
    })
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  overflow: hidden;
  padding: 18px 19px;
  .anchor {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 26px;
    div {
      margin-right: 40px;
      position: relative;
      cursor: pointer;
    }
    .checked {
      width: 23px;
      height: 4px;
      border-radius: 4px;
      background: #ff6d00;
      position: absolute;
      left: 50%;
      bottom: -10px;
      transform: translateX(-12px);
    }
    a {
      color: #000;
    }
  }
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .scrollContent {
    padding-right: 15px;
    height: calc(100vh - 220px);
    overflow-y: scroll;
    margin-top: 21px;
    .list {
      background: #f8fafc;
      margin: 22px 0;
      padding: 21px;
      position: relative;
      .qa {
        font-size: 16px;
        line-height: 30px;
        font-weight: bold;
      }
      .opiton {
        line-height: 50px;
      }
      .answer {
        font-weight: bold;
        line-height: 30px;
      }
      .grade {
        position: absolute;
        right: 10px;
        top: 0px;
        width: 33px;
        height: 35px;
        text-align: center;
        line-height: 30px;
        background-size: 100% 100%;
        font-style: italic;
      }
    }
  }
  .title {
    color: #000;
    display: flex;
    color: #4b6175;
    font-weight: 600;
    padding-bottom: 13px;
    margin-bottom: 20px;
    margin-top: 26px;
    align-items: flex-end;
    justify-content: space-between;
    border-bottom: 1px solid #e2e5e7;
    span {
      font-size: 15px;
    }
  }
  .base .title {
    margin-top: 0;
  }
  .overview {
    padding: 9px 20px;
    background: rgba(237, 242, 246, 0.35);
    font-weight: 500;
    font-size: 12px;
    color: #788aa3;
    line-height: 17px;
    margin-top: 15px;
    span {
      padding-right: 48px;
    }
  }
  .detail {
    position: relative;
    .noData {
      position: absolute;
      top: 52.5%;
      left: 51.5%;
      transform: translate(-50%, -50%);
      width: 97%;
      height: 75%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: linear-gradient(180deg, #fff 0%, #f1f7ff 100%);
      > img {
        width: 162px;
        height: 135px;
      }
      span {
        font-weight: bold;
        font-size: 12px;
        color: #8994a1;
        line-height: 17px;
        text-align: center;
        font-style: normal;
        margin-top: -28px;
      }
    }
  }
  .data {
    color: #000;
    margin-bottom: 5px;
    background: #f6f6f6;
    border-radius: 6px;
    padding: 10px 16px;
    span {
      font-weight: 550;
      font-size: 14px;
      color: #677f89;
      margin-right: 90px;
    }
  }
  .echart {
    width: 100%;
    height: 300px;
  }
  // .ant-table,
  // // .ant-btn {
  // //   color: #000;
  // // }
  // .ant-tabs {
  //   // height: calc(100% -70px);
  // }
  /deep/.ant-tabs-bar {
    border-bottom: 0;
  }
  /deep/.ant-tabs-nav.ant-tabs-nav-animated > div {
    width: 100%;
    display: flex;
    .ant-tabs-tab {
      color: #000;
      margin-right: 0;
      padding: 9px 22px 9px 0;
    }
  }
  /deep/.ant-tabs-nav-container-scrolling {
    padding-left: 0;
    padding-right: 64px;
  }
  /deep/.ant-tabs-tab-prev {
    margin-left: calc(100% - 64px);
  }
  /deep/.ant-tabs-tab-active.ant-tabs-tab {
    display: flex;
    font-weight: 550;
    justify-content: center;
    position: relative;
    justify-content: center;
    &:after {
      bottom: 0;
      content: '';
      width: 21px;
      height: 3px;
      border-radius: 3px;
      position: absolute;
      background: #ff6d00;
    }
  }
  /deep/.ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
    display: none !important;
  }
  .student-data {
    height: 100%;
    position: relative;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    /deep/.list-pagination {
      width: 100%;
      bottom: 40px;
      position: absolute;
      .pagination {
        padding: 12px 0 0;
      }
    }
  }
  .overall.student-data {
    padding-bottom: 40px;
  }
}
.lesson-data::-webkit-scrollbar {
  display: none;
}
</style>
<style lang="less">
.guidanceModal {
  .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: #fff;
  }
}
</style>
